module.exports = __webpack_public_path__ + "img/CLEAR_COLOR.d41d8cd9.svg";